module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashContent"
  }, [_c('banet-modal-confirm', {
    attrs: {
      "show": _vm.confirmDialog.show,
      "showFooter": true,
      "title": _vm.confirmDialog.title,
      "body": _vm.confirmDialog.body
    },
    on: {
      "confirmNo": function($event) {
        _vm.confirmDelete(false)
      },
      "confirmYes": function($event) {
        _vm.confirmDelete(true)
      }
    }
  }), _vm._v(" "), _c('banet-modal-info', {
    attrs: {
      "show": _vm.infoDialog.show,
      "showFooter": true,
      "title": _vm.infoDialog.title,
      "body": _vm.infoDialog.body
    },
    on: {
      "infoClose": function($event) {
        _vm.infoDialog.show = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-heading componentHeader"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getTranslation('lbl_panel_headline_timeplan')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 text-center"
  }, [_c('div', {
    staticClass: "center-block"
  }, [_c('strong', [_vm._v(_vm._s(_vm.getTranslation('lbl_ticket_filter')) + ":")]), _vm._v(" "), _c('el-select', {
    model: {
      value: (_vm.periodFilter),
      callback: function($$v) {
        _vm.periodFilter = $$v
      },
      expression: "periodFilter"
    }
  }, _vm._l((_vm.periodFilterOptions), function(option) {
    return _c('el-option', {
      key: option.val,
      attrs: {
        "label": option.label,
        "value": option.val
      }
    })
  })), _vm._v(" "), _c('banet-pagination', {
    attrs: {
      "count": _vm.count
    },
    on: {
      "pagingEvent": _vm.setPage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(!_vm.shouldShowAddNew) ? _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": !_vm.clientExists
    },
    on: {
      "click": _vm.showAddNew
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('btn_add_timeplan')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": '/history/timeplan/all/' + _vm.clientId,
      "tag": "button",
      "title": _vm.getTranslation('lbl_history')
    }
  }, [_c('i', {
    staticClass: "fa fa-history",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "timeplan clearfix"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_timeplan_period_start_time')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_timeplan_period_end_time')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_timeplan_period_contact')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.getTranslation('lbl_grid_col_action')))])])]), _vm._v(" "), (!_vm.loadingTimeplan) ? _c('tbody', [(_vm.shouldShowAddNew) ? _c('tr', {
    staticClass: "editable"
  }, [_c('td', [_c('banet-datetime-picker', {
    ref: "newDatePicker",
    attrs: {
      "placeholder": _vm.getTranslation('lbl_timeplan_select_datetime')
    },
    on: {
      "input": function($event) {
        _vm.selectDate('new', 'start', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('banet-datetime-picker', {
    ref: "newDatePicker",
    attrs: {
      "placeholder": _vm.getTranslation('lbl_timeplan_select_datetime')
    },
    on: {
      "input": function($event) {
        _vm.selectDate('new', 'end', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-select', {
    attrs: {
      "placeholder": _vm.getTranslation('lbl_timeplan_select_contact'),
      "no-data-text": _vm.getTranslation('lbl_timeplan_no_contacts')
    },
    model: {
      value: (_vm.newPeriod.contact),
      callback: function($$v) {
        _vm.newPeriod.contact = $$v
      },
      expression: "newPeriod.contact"
    }
  }, _vm._l((_vm.contacts), function(contact) {
    return _c('el-option', {
      key: contact._id,
      attrs: {
        "label": contact.name,
        "value": contact._id
      }
    })
  }))], 1), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "title": _vm.getTranslation('lbl_save')
    },
    on: {
      "click": _vm.saveNewPeriod
    }
  }, [_c('span', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "title": _vm.getTranslation('lbl_cancel')
    },
    on: {
      "click": _vm.hideAddNew
    }
  }, [_c('span', {
    staticClass: "fa fa-ban"
  })])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.timeplan), function(period, index) {
    return (_vm.timeplan && _vm.timeplan.length) ? _c('tr', [_c('td', {
      staticStyle: {
        "width": "310px",
        "white-space": "nowrap"
      }
    }, [(_vm.showEditID != period._id) ? [_vm._v("\n                        " + _vm._s(_vm.getFormattedDateString(period.startdate)) + "\n                    ")] : [_c('banet-datetime-picker', {
      attrs: {
        "placeholder": _vm.getTranslation('lbl_timeplan_select_datetime'),
        "value": _vm.editPeriod.startdate
      },
      on: {
        "input": function($event) {
          _vm.selectDate('edit', 'start', $event)
        }
      }
    })]], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "310px",
        "white-space": "nowrap"
      }
    }, [(_vm.showEditID != period._id) ? [_c('span', {
      class: {
        ongoing: !period.enddate
      }
    }, [_vm._v(" " + _vm._s(_vm.getFormattedDateString(period.enddate)))])] : [_c('banet-datetime-picker', {
      attrs: {
        "placeholder": _vm.getTranslation('lbl_timeplan_select_datetime'),
        "value": _vm.editPeriod.enddate
      },
      on: {
        "input": function($event) {
          _vm.selectDate('edit', 'end', $event)
        }
      }
    })]], 2), _vm._v(" "), _c('td', [(_vm.showEditID != period._id) ? [_c('span', {
      class: [period.contact && !period.contact.deleted ? '' : 'noContact']
    }, [_vm._v("\n                            " + _vm._s((period.contact && !period.contact.deleted) ? period.contact.name :
      _vm.getTranslation('lbl_no_contact_for_timeline_period')) + "\n                        ")])] : [_c('el-select', {
      attrs: {
        "placeholder": _vm.getTranslation('lbl_timeplan_select_contact'),
        "no-data-text": _vm.getTranslation('lbl_timeplan_no_contacts')
      },
      model: {
        value: (_vm.editPeriod.contact),
        callback: function($$v) {
          _vm.editPeriod.contact = $$v
        },
        expression: "editPeriod.contact"
      }
    }, _vm._l((_vm.contacts), function(contact) {
      return _c('el-option', {
        key: contact._id,
        attrs: {
          "label": contact.name,
          "value": contact._id
        }
      })
    }))]], 2), _vm._v(" "), _c('td', [(_vm.showEditID != period._id) ? [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "title": _vm.getTranslation('lbl_edit')
      },
      on: {
        "click": function($event) {
          _vm.showEdit(period._id, $event)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-pencil"
    })]), _vm._v(" "), (period._id && period._id.indexOf('empty_id') < 0) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": _vm.getTranslation('lbl_delete')
      },
      on: {
        "click": function($event) {
          _vm.shouldDeletePeriod(period._id)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e()] : [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "title": _vm.getTranslation('lbl_save')
      },
      on: {
        "click": _vm.saveEditPeriod
      }
    }, [_c('span', {
      staticClass: "fa fa-floppy-o"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn",
      attrs: {
        "title": _vm.getTranslation('lbl_cancel')
      },
      on: {
        "click": function($event) {
          _vm.hideEdit(period._id)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-ban"
    })])]], 2)]) : _vm._e()
  }), _vm._v(" "), (!_vm.timeplan || !_vm.timeplan.length) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.getTranslation('lbl_no_data')))])])]) : _vm._e()], 2) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-471eaaef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/protected/components/timeplan/Timeplan.vue
// module id = 675
// module chunks = 0